import { Injectable } from '@angular/core';
import { ListinoNazionale } from '../models/listinoNazionale.model';
import { PraticaFlowdy2_Firestore } from '../models/praticaFirestore.model';


@Injectable({
  providedIn: 'root',
})
export class StiliService{
  
  getMaterialIconStoricoListino(listino:ListinoNazionale) : string{
    if(!listino.eliminato){
      return 'check_circle';
    }else{
      return 'edit';
    }
   
  }

  
  

  getColoreIconaStoricoListino(listino:ListinoNazionale) : string{
    if(!listino.eliminato){
      return '#1C56AC';
    }else{
      return '#2D848A';
    }
  }
  getColoreIconaStoricoOda(operazione:string) : string{
    if(operazione.startsWith("CREAZIONE")){
      return '#246A73';
    }else if(operazione.startsWith("MODIFICATO VALORE IMPEGNATO")){
      return '#9191E9';
    }else if(operazione.startsWith("MODIFICATO VALORE DOVUTO PER FINE FASE 1")){
      return '#6184D8';
    }else if(operazione.startsWith("MODIFICATO VALORE PAGATO PER REGISTRAZIONE EM")){
      return '#457EAC';
    }
    return ''; 
    
  }

  getMaterialIconStoricoOda(operazione:string) : string{
    if(operazione.startsWith("CREAZIONE")){
      return 'add_circle';
    }else if(operazione.startsWith("MODIFICATO VALORE IMPEGNATO")){
      return 'edit_square';
    }else if(operazione.startsWith("MODIFICATO VALORE DOVUTO PER FINE FASE 1")){
      return 'payments';
    }else if(operazione.startsWith("MODIFICATO VALORE PAGATO PER REGISTRAZIONE EM")){
      return 'shopping_cart_checkout';
    }
    return ''; 
  }
  getMaterialIconStatoFlowdy(statoFlowdy:string, fase:number) : string{
    //console.log("-> getMaterialIconStatoFlowdy " + statoFlowdy + " "+fase);
    if(fase==1 || fase==2 || fase==3){
      switch (statoFlowdy) {
        case 'CARICATA':
          return 'upload_file';
        case 'DA ASSEGNARE':
          return 'person_off';
        case 'ASSEGNATA':
          return 'assignment_ind';
        case 'IN ATTESA ODA':
          return 'hourglass_top';
        case 'SOPRALLUOGO EFFETTUATO':
          return 'fact_check';
        case 'SOPRALLUOGO KO':
          return 'wrong_location';
        case 'PREVENTIVO IN ATTESA':
          return 'pending';
        case 'PREVENTIVO RIFIUTATO':
            return 'contract_delete';
        case 'PREVENTIVO APPROVATO':
          return 'order_approve';
        case 'CONSEGNATA':
          return 'assignment_turned_in';
        case 'IN VERIFICA SMARTFIBER':
          return 'engineering'
        case 'IN REWORK AZIENDA':
          return 'feedback'
        case 'IN CARICO PRESIDIO':
          return 'location_home'
        case 'PUBBLICATA':
          return 'publish'
        case 'VERIFICATA':
            return 'checklist';
        case 'IN REWORK':
            return 'reset_image';
        case 'RESPINTA':
            return 'gpp_bad';
        case 'APPROVATA':
            return 'verified';
        case 'APPUNTAMENTO FISSATO':
          return 'event';
        case 'INSTALLAZIONE EFFETTUATA':
          return 'router';
        case 'INSTALLAZIONE KO':
          return 'cancel';
        case 'IN ATTESA CONFERMA TIM SUPPORT':
          return 'unknown_document';
        case 'CONTROLLO TIM SUPPORT KO':
            return 'remove_done';
        case 'IN PROGETTAZIONE':
          return 'design_services';
        case 'IN FIRMA VERBALE':
          return 'signature';
        case 'VERBALE FIRMATO':
          return 'contract_edit';
        case 'FIRMATA':
          return 'library_add_check';
        case 'APPUNTAMENTO MANCATO':
          return 'event_busy';
        case 'CONTROLLO TIM SUPPORT OK':
          return 'fact_check';
        case 'ATTIVAZIONE KO CPE':
          return 'devices_off';
        case 'ATTIVAZIONE KO FO':
          return 'wifi_off';
        case 'SOPRALLUOGO PIANIFICATO':
          return 'calendar_clock';
        case 'KO VINCOLATA':
            return 'cancel';
        case 'PRESENTATA':
          return 'send';
        default:
          return 'person_off';
      }
    }
    return ''
  }

  getColoreRifiutataFase1(pratica:PraticaFlowdy2_Firestore):string{
    const oggi = new Date();
    const dataRisposta = pratica.dataRispostaInfratelFase1.toDate(); 
    const diffTime = Math.abs(oggi.getTime() - dataRisposta.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
    if(diffDays>= 10){
      return 'red';
    }else{
      return '#F9A03F'
    }
  }

  getIconaPermessoFase2(pratica:PraticaFlowdy2_Firestore):string{
    if(pratica.servePermessoEntePubblico ){
      if(!pratica.permessoUploaded){
        return 'scan_delete';
      }else{
        return 'task'
      }
    }
    return '';
  }
  getColoreIconaPermessoFase2(pratica:PraticaFlowdy2_Firestore):string{
    if(pratica.servePermessoEntePubblico ){
      if(!pratica.permessoUploaded){
        return '#9A48D0';
      }else{
        return '#034748'
      }
    }
    return '';
  }


  getColoreIconaStatoFlowdyFase3(pratica:PraticaFlowdy2_Firestore):string{
    if(pratica.statoFlowdyFase3 === 'IN PROGETTAZIONE' 
      || pratica.statoFlowdyFase3 === 'DA ASSEGNARE' 
      || pratica.statoFlowdyFase3 === 'ASSEGNATA'
      || pratica.statoFlowdyFase3 === 'IN ATTESA ODA'
      ){
        if(!pratica.coordinateCentrale || !pratica.coordinateScuola){
          return '#C62724';
        }else{
          return this.getColoreIconaStatoFlowdy(pratica.statoFlowdyFase3, 3);
        }
        
    }else{
      return this.getColoreIconaStatoFlowdy(pratica.statoFlowdyFase3, 3);
    }
  }
  getColoreIconaStatoFlowdy(statoFlowdy:string, fase:number) : string{
    switch (statoFlowdy) {

      case 'CARICATA':
          return '#E7DE7A';
      case 'DA ASSEGNARE':
        return '#F9A03F';
      case 'ASSEGNATA':
        return '#1C56AC';
      case 'IN ATTESA ODA':
        return '#FCAB10';
      case 'SOPRALLUOGO EFFETTUATO':
        return '#44AF69';
      case 'SOPRALLUOGO KO':
        return '#F8333C';
      case 'PREVENTIVO IN ATTESA':
        return '#2B9EB3';
      case 'PREVENTIVO RIFIUTATO':
          return '#EB9B33';
      case 'PREVENTIVO APPROVATO':
        return '#83C48F';
      case 'CONSEGNATA':
        return '#90BF18';
      case 'IN VERIFICA SMARTFIBER':
        return '#67AAF9'
      case 'IN REWORK AZIENDA':
        return '#F9A03F'
      case 'IN CARICO PRESIDIO':
        return '#0091AD'
      case 'PUBBLICATA':
        return '#2B4162'
      case 'APPROVATA':
        return '#0B6E4F'
      case 'RESPINTA':
        return '#721817'
      case 'VERIFICATA':
        return '#3F6965';
      case 'IN REWORK':
        return '#C44536';
      case 'APPUNTAMENTO FISSATO':
        return '#373F51';
      case 'INSTALLAZIONE EFFETTUATA':
        return '#58A4B0';
      case 'INSTALLAZIONE KO':
        return '#E07A5F';
      case 'IN ATTESA CONFERMA TIM SUPPORT':
        return '#11B5E4';
      case 'CONTROLLO TIM SUPPORT KO':
        return '#D10000';
      case 'IN PROGETTAZIONE':
        return '#17B890';
      case 'IN FIRMA VERBALE':
        return '#EAB464';
      case 'VERBALE FIRMATO':
        return '#37C193';
      case 'FIRMATA':
        return '#2BB14B';
      case 'APPUNTAMENTO MANCATO':
        return '#C42021';
      case 'CONTROLLO TIM SUPPORT OK':
        return '#295135';
      case 'ATTIVAZIONE KO CPE':
        return '#FA824C';
      case 'ATTIVAZIONE KO FO':
        return '#4B3F72';
      case 'SOPRALLUOGO PIANIFICATO':
        return '#5C80BC';
      case 'KO VINCOLATA':
        return '#F8333C';
      case 'PRESENTATA':
        return '#4A90E2';
      default:
        return '#1C56AC';
    }
  }

  getMaterialIconSopralluogoFase1(pratica:PraticaFlowdy2_Firestore):string{
   
    if(!pratica.dataSopralluogo){
        return 'event_upcoming';
    }else{
      
      if(pratica.statoFlowdyFase1==='SOPRALLUOGO PIANIFICATO'){
        return 'event_available';
      }else if(pratica.statoFlowdyFase1==='APPROVATA'){
        return 'where_to_vote';
      }else{
        if(pratica.sopralluogoOk){
          return 'where_to_vote';
        }else{
          return 'gpp_bad';
        }
      }
      
    }
  }

  getColoreIconaSopralluogoFase1(pratica:PraticaFlowdy2_Firestore):string{
    if(!pratica.dataSopralluogo){
      return '#1C56AC';
    }else{
      if(pratica.statoFlowdyFase1==='SOPRALLUOGO PIANIFICATO'){
        return '#5C80BC';
      }else if(pratica.statoFlowdyFase1==='APPROVATA'){
        return '#51BDA2';
      }else{
        if(pratica.sopralluogoOk){
          return '#51BDA2';
        }else{
          return '#F6AE2D';
        }
      }
       
    }
  }

  getMaterialIconOpereExtra(pratica:PraticaFlowdy2_Firestore):string{

    if(pratica.opereExtra!=null){
      if(!pratica.opereExtra){
        return 'block';
      }else{
          return 'add_home_work'
      }
    }else{
      return '';
    }
   
  }
  
  getColoreIconaOpereExtra(pratica:PraticaFlowdy2_Firestore):string{
    if(!pratica.opereExtra){
      return '#ACD7EC';
    }else{
      return '#2D93AD';
    }
  }
  

  getMaterialIconStatoPreventivo(pratica:PraticaFlowdy2_Firestore):string{
    if(pratica.statoPreventivo==='IN ATTESA'){
        return 'pending_actions';
    }else if(pratica.statoPreventivo==='APPROVATO'){
      return 'price_check';
    }else{
        return 'unpublished'
    }
  }

  getColoreIconaStatoPreventivo(pratica:PraticaFlowdy2_Firestore):string{
    if(pratica.statoPreventivo==='IN ATTESA'){
      return '#F1D302';
    }else if(pratica.statoPreventivo==='APPROVATO'){
      return '#8DE969';
    }else{
        return '#C1292E'
    }
  }

  getCategoriaKOPFColor(categoriaAttesa:string):string{
    let categoriaAttesaColor = '';
    switch (categoriaAttesa) {
      case "Problema Tripletta OF":
        categoriaAttesaColor = '#888098'
        break;
      case "Problema Permuta PCN":
        categoriaAttesaColor = '#72A98F'
        break;
      case "Problema Centrale OLT":
        categoriaAttesaColor = '#4C7087'
        break;
      case "Problema Fibra Fibercop":
        categoriaAttesaColor = '#6C6159'
        break;
      case "Problema Fibra OF":
        categoriaAttesaColor = '#8A817C'
        break;
      case "Problema Fibra Infratel":
        categoriaAttesaColor = '#BCB8B1'
        break;
      case "Problema Altro":
        categoriaAttesaColor = '#E0AFA0'
        break;
      case "Cassetto Ottico Assente":
        categoriaAttesaColor = '#8CA0D7'
        break;
      case "Causa Cliente":
        categoriaAttesaColor = '#5ED1C4'
        break;
      default:
        categoriaAttesaColor = '#28464B'
        break;
    }
    return categoriaAttesaColor;
  }
  getStatoInfratelColor(stato:string):string{
    let coloreStatoInfratel = '';
      switch (stato) {
        case "1-1":
        case "2-1":
          coloreStatoInfratel = '#BCCDD5'
          break;
        case "1-2":
        case "2-2":
          coloreStatoInfratel = '#E7F4FB'
          break;
        case "1-3":
        case "2-3":
          coloreStatoInfratel = '#DCEFF9'
          break;
        case "1-4":
        case "2-4":
          coloreStatoInfratel = '#C4E4F5'
          break;
        case "1-5":
        case "2-5":
            coloreStatoInfratel = '#FFD0D0'
            break;
        case "1-6":
        case "2-6":
            coloreStatoInfratel = '#D4F1DC'
            break;
        default:
          coloreStatoInfratel = '#326F6F'
          break;
      }
      return coloreStatoInfratel;
    }

    getStatoPFIcon(stato:string):string{

      let iconaStatoPF = '';
        switch (stato) {
          case "IN ATTESA":
            iconaStatoPF = 'hourglass_empty'
            break;
          case "PRONTO":
            iconaStatoPF = 'moving_ministry'
            break;
          case "ROUTER INSTALLATO":
            iconaStatoPF = 'cell_wifi'
            break;
          case "SEDE ATTIVATA":
            iconaStatoPF = 'verified'
            break;
          case "KO":
            iconaStatoPF = 'link_off'
            break;
         default:
            iconaStatoPF = 'hourglass_empty'
            break;
        }
        return iconaStatoPF;
      }
    getStatoPFColor(stato:string):string{
      let coloreStatoPF = '';
        switch (stato) {
          case "IN ATTESA":
            coloreStatoPF = '#FFAD69'
            break;
          case "PRONTO":
            coloreStatoPF = '#47A8BD'
            break;
          case "ROUTER INSTALLATO":
            coloreStatoPF = '#A9BCD0'
            break;
          case "SEDE ATTIVATA":
            coloreStatoPF = '#AED89A'
            break;
          case "KO":
            coloreStatoPF = '#BB6B00'
            break;
         default:
            coloreStatoPF = '#326F6F'
            break;
        }
        return coloreStatoPF;
      }
      getColoreFaseKO(fase:number):string{
        switch (fase) {
          case 0:
            return '#B3C0A4';
          case 1:
            return '#8BAAAD';
          case 2:
            return '#85C7DE';
          case 3:
            return '#7C72A0';
          default:
            return '#B3C0A4';
        }
      }
      getColoreCategoriaVincoloKO(tipologia:number):string{
        switch (tipologia) {
          case 1:
            return '#2274A5';
          case 2:
            return '#505168';
          case 3:
            return '#EDAE49';
          case 4:
            return '#E85F5C';  
          default:
            return '#773344';
        }
      }

      getColoreCategoriaVincoloOF(categoriaCodice:string):string{
        if(!categoriaCodice){
          return '#e0e0e0';
        }
        categoriaCodice = categoriaCodice.substring(0,3);
        switch (categoriaCodice) {
          case '2.1':
            return '#2274A5'; // Blu
          case '2.2':
            return '#505168'; // Grigio scuro
          case '2.3':
            return '#EDAE49'; // Arancione
          case '2.4':
            return '#E85F5C'; // Rosso
          case '2.5':
            return '#6B9AC4'; // Blu chiaro
          case '2.6':
            return '#97D8C4'; // Verde acqua
          case '2.7':
            return '#F4A261'; // Arancione chiaro
          case '2.8':
            return '#E76F51'; // Rosso corallo
          case '2.9':
            return '#264653'; // Verde scuro
          default:
            return '#773344';
        }
      }
      getColoreCausaKO(causa:string):string{
        switch (causa.toUpperCase()) {
          case 'RISTRUTTURAZIONE':
            return '#696773';
          case 'MANCANZA ALUNNI':
            return '#3587A4';
          case 'MANCANZA ADESIONE':
            return '#E08D79';
          case "VINCOLATA FIBERCOP":
            return '#FFAD69';
          case "VINCOLATA RISTRUTTURAZIONE":
            return '#47A8BD';
          case "VINCOLATA DIMENSIONAMENTO":
            return '#A9BCD0';
          case "VINCOLATA TIPO A":
            return '#AED89A';
          case "VINCOLATA TIPO C":
            return '#BB6B00';
          case "VINCOLATA DISMISSIONE":
            return '#817F82';
          case "VINCOLATA MANCANZA ALUNNI":
            return '#A5B5BF';
          case "VINCOLATA PERMESSO":
            return '#7899D4';
          case "VINCOLATA MANCA ADESIONE":
            return '#1F2041';
          case 'ALTRO':
            return '#133C55';
          default:
            return '#9BC4CB';
        }
      }
      getColoreVincoloKO(tipoVincolo:string):string{
        let coloreTipoVincolo = '';
          switch (tipoVincolo) {
            case "VINCOLATA FIBERCOP":
              coloreTipoVincolo = '#FFAD69'
              break;
            case "VINCOLATA RISTRUTTURAZIONE":
              coloreTipoVincolo = '#47A8BD'
              break;
            case "VINCOLATA DIMENSIONAMENTO":
              coloreTipoVincolo = '#A9BCD0'
              break;
            case "VINCOLATA TIPO A":
              coloreTipoVincolo = '#AED89A'
              break;
            case "VINCOLATA TIPO C":
              coloreTipoVincolo = '#BB6B00'
              break;
            case "VINCOLATA DISMISSIONE":
              coloreTipoVincolo = '#817F82'
              break;
            case "VINCOLATA MANCANZA ALUNNI":
              coloreTipoVincolo = '#A5B5BF'
              break;
            case "VINCOLATA PERMESSO":
              coloreTipoVincolo = '#7899D4'
              break;
            case "VINCOLATA MANCA ADESIONE":
              coloreTipoVincolo = '#1F2041'
              break;
           default:
              coloreTipoVincolo = '#326F6F'
              break;
          }
          return coloreTipoVincolo;
        }


      

  }
